/**
 * START PAGE ENTRY POINT
 *
 * @version 0.1
 */

import React from 'react';
import reduxStore from './../../reduxStore';
import headerActions from './../../reusable/Header/Header.actions';
import actions from './StartPage.actions';
import xhr from './../../utils/xhr';
import utils from './../../utils/utilities';
import BatchUpload from './../BatchUpload/BatchUpload.index.jsx';
import DashboardNoActiveEntities from './DashboardNoActiveEntities/DashboardNoActiveEntities.jsx';
import Dashboard from './Dashboard/Dashboard';
import LimitedAccessUser from './LimitedAccessUser/LimitedAccessUser';
import Spinnable from './../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper.jsx';
import { userHas, permissions } from "../../permissions";

class StartPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = reduxStore.getState();
    }

    componentWillMount() {

        headerActions.updateHeader('emptySubMenu');
        this.props.spinner.showSpinner();

        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState());
            }
        );

        actions.dashboardReset();
        actions.setSpinners();
        actions.getAllData()
            .then((response) => {
                let dashboardInfo = this.state.dashboardState.dashboardInfo;
                dashboardInfo.active != 0 ?
                    headerActions.updateHeader('getStartedDashboard') :
                    headerActions.updateHeader('getStartedReturningUser');
                this.props.spinner.hideSpinner();
            })
            .catch((error) => {
                this.props.spinner.hideSpinner();
                utils.logError(error, "ViewFeedArticle.componentWillMount():");
                xhr.handleAllErrors(error);
            });
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    render() {

        let dashboardInfo = this.state.dashboardState.dashboardInfo;

        if (this.state.dashboardState.dashboardStage === "DASHBOARD_WITH_COMPANIES" &&
            dashboardInfo.active != 0 && dashboardInfo.active != 'N/A') {

            return (
                <div className="start-page-wrapper">
                    <Dashboard data={this.state.dashboardState.dashboardInfo} userPreferences={this.state.user.preferences} />
                </div>
            );
        }

        if (this.state.dashboardState.dashboardStage === "DASHBOARD_NO_COMPANIES") {
            if(!(userHas(permissions.entities.edit) && userHas(permissions.categories.edit))) {
                return (
                    <LimitedAccessUser />
                );
            }
            return (
                <BatchUpload location={this.props.location} />
            );
        }

        return (
            !(userHas(permissions.entities.edit) && userHas(permissions.categories.edit)) ?
                <LimitedAccessUser /> :
                <DashboardNoActiveEntities data={this.state.dashboardState.dashboardInfo}
                                           helpUrlRoot={this.state.user.helpUrlRoot} />
        );
    }

}

export default Spinnable(StartPage);


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/StartPage.index.jsx